export interface TimelineNode {
  time: string;
  title: string;
  desc: string;
}

export interface Perspective {
  name: string;
  role: string;
  stance: string;
}

export interface AnalysisBlock {
  title: string;
  desc: string;
}

export interface Topic {
  id: string;
  title: string;
  categoryId: string;
  summary: string;
  cover: string;
  publishedAt: string;
  readMinutes: number;
  heat: number;
  sources: number;
  tags: string[];
  keywords: string;
  timeline: TimelineNode[];
  perspectives: Perspective[];
  analysis: AnalysisBlock[];
}

export interface Category {
  id: string;
  name: string;
  icon: string;
  desc: string;
}

export const siteInfo = {
  name: "黑料热点",
  slogan: "把碎片拼成完整脉络",
  intro:
    "黑料热点是一个专注热点事件时间线梳理的内容复盘站。我们从事件起因追到各方回应，再把背后真相与深层原因逐层剥开，给你一份看得懂、查得到的完整复盘。",
  email: "contact@heiliao-hot.example",
  contactNote: "合作、纠错与内容建议，欢迎通过邮件或订阅表单联系我们。",
};

export const categories: Category[] = [
  { id: "brand", name: "品牌风波", icon: "ri-store-2-line", desc: "品牌营销与定价争议的来龙去脉" },
  { id: "event", name: "活动现场", icon: "ri-mic-line", desc: "演出、赛事与线下活动的突发状况" },
  { id: "content", name: "内容争议", icon: "ri-movie-2-line", desc: "影视综艺与短视频的表达之争" },
  { id: "ecom", name: "电商消费", icon: "ri-shopping-bag-3-line", desc: "直播带货与售后环节的纠纷复盘" },
  { id: "rights", name: "版权纠纷", icon: "ri-copyright-line", desc: "原创内容归属与授权边界的梳理" },
  { id: "consumer", name: "消费质疑", icon: "ri-restaurant-2-line", desc: "餐饮与服务体验引发的公共讨论" },
];

export const topics: Topic[] = [
  {
    id: "qinghe-lianming",
    title: "青禾乳业联名定价争议：一场从「情怀」到「割韭菜」的舆论反转",
    categoryId: "brand",
    summary:
      "联名款上线三小时售罄，随后被质疑同款配料换壳涨价。从品牌方回应到代工厂发声，我们把这场争议的时间线与多方立场完整梳理。",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20product%20photography%20of%20a%20plain%20milk%20carton%20beside%20a%20paper%20price%20tag%20on%20a%20warm%20cream%20studio%20background%2C%20soft%20natural%20light%2C%20editorial%20magazine%20still%20life%2C%20muted%20tones%2C%20high%20detail&width=1200&height=800&seq=hei-topic-qinghe&orientation=landscape",
    publishedAt: "2026-08-21",
    readMinutes: 8,
    heat: 92,
    sources: 17,
    tags: ["品牌营销", "定价争议", "联名款"],
    keywords: "青禾乳业联名争议,联名涨价,品牌风波复盘",
    timeline: [
      { time: "08-14 10:00", title: "联名概念预热", desc: "青禾乳业发布手绘预告海报，宣布与独立插画师联名，主打「小时候的味道」。" },
      { time: "08-16 20:00", title: "首发三小时售罄", desc: "联名款首批上架，官方直播间标注「限量」，页面显示售罄并开启预约。" },
      { time: "08-17 09:30", title: "配料表对比出现", desc: "有消费者对比发现联名款与常规款配料顺序接近，价格却高出约四成，截图开始扩散。" },
      { time: "08-17 16:00", title: "话题冲上热榜", desc: "「换壳涨价」「情怀税」等表述登上多个平台讨论榜，话题阅读量快速攀升。" },
      { time: "08-18 11:00", title: "品牌首次回应", desc: "品牌方说明联名包含设计授权与包装成本，并称定价经过成本核算，但未公开具体明细。" },
      { time: "08-19 15:00", title: "代工厂侧面发声", desc: "有自称供应链人士的账号称「内容物差异有限」，随后该表述被品牌方否认并称其非授权代表。" },
      { time: "08-20 18:00", title: "补充说明与调整", desc: "品牌方追加说明，承诺开放成本构成问答，并对已购用户提供差额权益选项。" },
    ],
    perspectives: [
      { name: "品牌方", role: "青禾乳业官方", stance: "强调联名包含设计授权、限定包装与产能投入，定价合理，并否认配料完全等同的说法。" },
      { name: "消费者代表", role: "首发购买用户", stance: "认为宣传语强调「小时候的味道」，却缺少价格透明说明，感受更像情绪营销而非产品升级。" },
      { name: "营销观察者", role: "品牌营销从业者", stance: "认为问题不在联名本身，而在预热阶段制造稀缺却未同步解释溢价来源，导致预期落差。" },
    ],
    analysis: [
      { title: "争议的起点是信息差，而非价格本身", desc: "联名溢价在行业内并不罕见，真正触发情绪的是预热期强调情怀、却把成本结构留到争议后才解释。" },
      { title: "「限量」叙事放大了落差", desc: "先制造稀缺再解释定价，用户会默认稀缺等于价值，一旦发现差异有限，落差感被成倍放大。" },
      { title: "复盘价值：把溢价讲在前面", desc: "如果品牌在首发页面同步说明授权、包装与产能成本，这场讨论大概率停留在产品层面而非信任层面。" },
    ],
  },
  {
    id: "shenglang-tuipiao",
    title: "声浪音乐节退票事件：暴雨停演之后，谁该为票款负责",
    categoryId: "event",
    summary:
      "因突降暴雨演出中断，观众要求全额退款，主办方给出延期与折价两种方案。多方回应交错之下，我们把责任边界与处理节奏一次说清。",
    cover:
      "https://readdy.ai/api/search-image?query=outdoor%20music%20festival%20crowd%20at%20dusk%20with%20stage%20lights%20and%20light%20rain%2C%20warm%20tones%2C%20editorial%20photojournalism%2C%20high%20detail&width=1200&height=800&seq=hei-topic-shenglang&orientation=landscape",
    publishedAt: "2026-08-09",
    readMinutes: 7,
    heat: 88,
    sources: 21,
    tags: ["演出中断", "退票", "现场安全"],
    keywords: "音乐节退票,演出中断退款,活动现场复盘",
    timeline: [
      { time: "08-02 15:00", title: "气象预警发布", desc: "当地发布强对流天气提示，主办方公告称演出照常，建议自备雨具。" },
      { time: "08-02 19:40", title: "演出中途停演", desc: "主舞台因雷电预警中断，现场广播引导观众离场，部分乐队演出取消。" },
      { time: "08-02 22:10", title: "现场秩序引发讨论", desc: "散场高峰期间接驳车运力不足，相关视频开始在网络传播。" },
      { time: "08-03 10:00", title: "主办方首份公告", desc: "提出两套方案：保留票根兑换延期场次，或按比例退还部分票款。" },
      { time: "08-04 14:00", title: "观众集体诉求", desc: "多名观众认为停演属于主办方风险范畴，要求全额退款并对接驳安排给出说明。" },
      { time: "08-05 17:00", title: "监管介入协调", desc: "属地相关部门表示已了解情况，协调主办方就退改规则与观众沟通。" },
      { time: "08-07 12:00", title: "方案调整", desc: "主办方补充说明全额退款通道与时间表，并对现场接驳运力不足致歉。" },
    ],
    perspectives: [
      { name: "主办方", role: "声浪音乐节", stance: "称停演系不可抗力，已第一时间启动应急预案，并强调延期方案是为保留演出体验。" },
      { name: "购票观众", role: "现场参与者", stance: "认为天气预警早于演出发布，主办方本可提前决策，风险不应完全由观众承担。" },
      { name: "演出行业从业者", role: "票务与演出运营", stance: "指出国内演出票务对不可抗力的退改约定并不统一，事前规则透明度是矛盾高发点。" },
    ],
    analysis: [
      { title: "不确定性决策比天气更关键", desc: "真正的争议点并非暴雨，而是预警发布后到停演之间，主办方是否给出了清晰的决策与沟通节奏。" },
      { title: "退改规则应在售票前写清", desc: "若售票页面明确不可抗力的分级处理方式，观众在购票时就能形成合理预期，冲突空间会明显缩小。" },
      { title: "现场保障是第二战场", desc: "散场接驳与广播引导属于体验底线，这一环节的缺失往往会把票款争议放大成整体信任问题。" },
    ],
  },
  {
    id: "xingye-jianji",
    title: "星野剧场综艺剪辑争议：一个镜头如何改变观众对选手的判断",
    categoryId: "content",
    summary:
      "节目片段被指剪辑放大冲突，选手与节目组各执一词。从放出花絮到复盘完整素材，我们梳理这场「剪辑争议」的关键节点。",
    cover:
      "https://readdy.ai/api/search-image?query=video%20editing%20timeline%20on%20a%20monitor%20with%20a%20clapperboard%20on%20a%20warm-toned%20studio%20desk%2C%20editorial%20still%20life%2C%20soft%20light%2C%20high%20detail&width=1200&height=800&seq=hei-topic-xingye&orientation=landscape",
    publishedAt: "2026-07-28",
    readMinutes: 6,
    heat: 79,
    sources: 13,
    tags: ["综艺剪辑", "叙事争议", "节目组回应"],
    keywords: "综艺剪辑争议,节目剪辑复盘,内容争议",
    timeline: [
      { time: "07-19 21:00", title: "争议片段播出", desc: "节目中一段对话仅呈现单方情绪化表述，播出后相关话题迅速发酵。" },
      { time: "07-20 08:00", title: "选手发文回应", desc: "当事选手称完整对话有前后语境，被剪掉的部分才是解释动机的关键。" },
      { time: "07-20 14:00", title: "节目组说明", desc: "节目组称剪辑以叙事节奏为导向，不存在刻意引导，并表示尊重选手表达。" },
      { time: "07-21 20:00", title: "花絮片段放出", desc: "节目组上线加长版花絮，补充了部分上下文，讨论出现分化。" },
      { time: "07-23 10:00", title: "从业者讨论升温", desc: "多名后期从业者加入讨论，科普「情绪锚点」「节奏断点」等常见剪辑手法。" },
      { time: "07-25 16:00", title: "节目组承诺调整", desc: "节目组表示后续将增加上下文的呈现，并对容易产生误读的段落做说明。" },
    ],
    perspectives: [
      { name: "节目组", role: "星野剧场制作方", stance: "强调剪辑服务于节目节奏，无意引导观众对选手的评价，并称未删改核心事实。" },
      { name: "当事选手", role: "节目参与者", stance: "认为语境被移除后，表达被误读，希望完整素材得到呈现。" },
      { name: "后期从业者", role: "综艺剪辑师", stance: "指出镜头顺序与反应镜头叠加会显著改变理解，制作方应关注呈现的公平性。" },
    ],
    analysis: [
      { title: "剪辑是表达，不是中立记录", desc: "镜头顺序与反应镜头的组合天然带有立场，争议的本质是观众开始意识到「呈现即观点」。" },
      { title: "补上下文是最有效的止损", desc: "花絮放出后讨论降温，说明透明比辩解更能修复信任，观众真正想看到的是完整语境。" },
      { title: "行业需要剪辑伦理共识", desc: "当冲突被当作流量引擎，节目与参与者之间的信任成本会持续上升，长期看对内容生态不利。" },
    ],
  },
  {
    id: "yunfan-shouhou",
    title: "云帆直播间售后风波：从「七天可退」到退货被拒的完整链路",
    categoryId: "ecom",
    summary:
      "直播间承诺的售后条件与平台实际规则出现偏差，消费者退货被拒。我们按时间顺序还原承诺、下单与售后三个环节的错位。",
    cover:
      "https://readdy.ai/api/search-image?query=packing%20boxes%20and%20a%20laptop%20with%20live%20streaming%20setup%20on%20a%20warm%20neutral%20desk%2C%20e-commerce%20editorial%20still%20life%2C%20soft%20light%2C%20high%20detail&width=1200&height=800&seq=hei-topic-yunfan&orientation=landscape",
    publishedAt: "2026-07-11",
    readMinutes: 7,
    heat: 84,
    sources: 15,
    tags: ["直播带货", "售后争议", "退货规则"],
    keywords: "直播间售后,退货被拒复盘,电商消费争议",
    timeline: [
      { time: "06-28 20:30", title: "直播间口头承诺", desc: "主播在讲解时称「不合适随时退，七天无理由」，但未在商品页同步标注。" },
      { time: "06-29 09:00", title: "用户下单", desc: "消费者基于直播表述下单，商品页详情未出现相关售后说明。" },
      { time: "07-03 10:00", title: "申请退货被拒", desc: "用户以尺码不合适申请退货，客服以商品属于特定类目为由拒绝。" },
      { time: "07-03 18:00", title: "截图扩散", desc: "直播间录屏与客服对话截图被发布，讨论集中于「口头承诺是否算数」。" },
      { time: "07-05 11:00", title: "商家回应", desc: "商家称主播表述不够严谨，正核实相关片段，并提出先行垫付运费的处理方案。" },
      { time: "07-07 15:00", title: "平台介入", desc: "平台表示将依据承诺一致性原则核查直播录屏，并阶段性限制相关账号的售后争议类目推广。" },
      { time: "07-09 10:00", title: "规则补充上线", desc: "商家在商品页补充售后说明，并公开承诺对争议订单按直播表述执行。" },
    ],
    perspectives: [
      { name: "消费者", role: "下单用户", stance: "认为直播间的公开承诺构成购买依据，商家不应事后以「表述不严谨」为由推翻。" },
      { name: "商家", role: "云帆旗舰店", stance: "承认主播表述口径需统一，但强调客服是依照类目规则执行，并非故意推诿。" },
      { name: "平台规则研究者", role: "电商合规顾问", stance: "指出直播口头承诺与商品页规则不一致时，应优先保障消费者对承诺的合理信赖。" },
    ],
    analysis: [
      { title: "承诺一致性才是争议核心", desc: "问题不在七天无理由规则本身，而在于直播间表述与商品页规则出现两套标准时，消费者的合理信赖如何被保护。" },
      { title: "口头承诺正在被制度化", desc: "随着直播录屏成为普遍证据，平台与商家都开始把口头承诺纳入售后处理依据，这是明显进步。" },
      { title: "统一口径比事后道歉更有效", desc: "如果直播间话术与商品页规则在开播前就已对齐，绝大多数售后争议根本不会发生。" },
    ],
  },
  {
    id: "mulin-duanju",
    title: "沐林短剧版权之争：同一段剧情，两个团队都说自己是原创",
    categoryId: "rights",
    summary:
      "两部短剧被指剧情高度相似，双方先后晒出创作时间线。我们梳理授权、发布与维权三个环节，还原这场版权争议的关键节点。",
    cover:
      "https://readdy.ai/api/search-image?query=stack%20of%20script%20papers%20and%20film%20reels%20on%20a%20warm%20cream%20desk%2C%20editorial%20copyright%20concept%20still%20life%2C%20soft%20light%2C%20high%20detail&width=1200&height=800&seq=hei-topic-mulin&orientation=landscape",
    publishedAt: "2026-06-24",
    readMinutes: 6,
    heat: 71,
    sources: 12,
    tags: ["短剧版权", "原创归属", "维权"],
    keywords: "短剧版权纠纷,原创归属复盘,版权争议",
    timeline: [
      { time: "05-30 12:00", title: "A 团队作品上线", desc: "沐林工作室的短剧在平台上线，单集播放量快速攀升。" },
      { time: "06-06 20:00", title: "B 团队提出质疑", desc: "另一制作团队发文称剧情结构、人物关系与自家剧本高度相似。" },
      { time: "06-07 10:00", title: "双方各晒时间线", desc: "A 团队公布剧本修改记录，B 团队公布更早的创作手稿，讨论陷入胶着。" },
      { time: "06-09 15:00", title: "平台介入核查", desc: "平台表示已启动内容比对流程，涉事作品暂维持在线但限制推广。" },
      { time: "06-12 11:00", title: "授权链条被追问", desc: "有第三方编剧称曾向两家投稿相同大纲，授权链条成为新的焦点。" },
      { time: "06-18 16:00", title: "进入协商阶段", desc: "双方表示愿意就授权与署名问题进行协商，平台同步保留核查结论。" },
    ],
    perspectives: [
      { name: "沐林工作室", role: "被质疑方", stance: "称剧本为独立创作，愿意公开创作文档接受比对，强调相似不等于抄袭。" },
      { name: "质疑方团队", role: "更早上线剧本方", stance: "认为结构与人物关系的重合度过高，超出「巧合」范围，要求核查授权来源。" },
      { name: "版权律师", role: "知识产权从业者", stance: "指出创意本身不受保护，但独创性表达受保护，维权关键在于固定创作证据链。" },
    ],
    analysis: [
      { title: "相似的边界需要证据而非印象", desc: "观众感知到的「像」与法律意义上的「抄袭」之间存在距离，真正决定结果的是创作时间与表达比对。" },
      { title: "授权链条是最被忽视的风险点", desc: "当同一大纲被多头投稿，原创团队往往在不知情的情况下失去主张基础，这是行业普遍隐患。" },
      { title: "留痕是创作者的自我保护", desc: "从大纲到终稿的过程记录越完整，维权成本越低，这也是本次事件给从业者最直接的提醒。" },
    ],
  },
  {
    id: "haiyu-canting",
    title: "海屿餐厅卫生质疑：一段后厨视频引发的连锁反应",
    categoryId: "consumer",
    summary:
      "探店视频拍到后厨画面后引发卫生质疑，餐厅与拍摄者各执一词。我们按时间顺序梳理质疑、回应与复查的完整过程。",
    cover:
      "https://readdy.ai/api/search-image?query=empty%20restaurant%20table%20with%20a%20minimal%20place%20setting%20and%20warm%20daylight%2C%20editorial%20food%20magazine%20still%20life%2C%20high%20detail&width=1200&height=800&seq=hei-topic-haiyu&orientation=landscape",
    publishedAt: "2026-06-05",
    readMinutes: 5,
    heat: 66,
    sources: 9,
    tags: ["餐饮卫生", "探店视频", "消费质疑"],
    keywords: "餐厅卫生质疑,探店视频争议,消费维权复盘",
    timeline: [
      { time: "05-26 19:00", title: "探店视频发布", desc: "博主发布的探店视频中，后厨出现操作台摆放杂乱的画面。" },
      { time: "05-27 09:00", title: "话题开始发酵", desc: "相关片段被截图传播，部分消费者在点评平台上给出差评。" },
      { time: "05-27 15:00", title: "餐厅回应", desc: "餐厅称画面为交接班时段，已启动内部整改，并邀请顾客到店参观后厨。" },
      { time: "05-28 11:00", title: "博主补充说明", desc: "博主表示视频未刻意剪辑，并公开原始素材的时间码。" },
      { time: "05-30 10:00", title: "第三方复查", desc: "属地相关部门到店检查，指出部分区域布局需调整，未发现明显的食材存放问题。" },
      { time: "06-02 14:00", title: "整改公示", desc: "餐厅公示整改措施，包括操作区重新划分与员工流程培训。" },
    ],
    perspectives: [
      { name: "餐厅", role: "海屿餐厅", stance: "承认交接班管理存在疏漏，已按要求整改，并强调食材采购环节未发现问题。" },
      { name: "拍摄博主", role: "探店内容创作者", stance: "称拍摄与发布均保留原始素材，目的是提醒消费者关注用餐环境，无商业动机。" },
      { name: "消费者", role: "附近食客", stance: "希望看到持续的整改反馈，而不是一次性的公开说明。" },
    ],
    analysis: [
      { title: "视频片段与真实管理的距离", desc: "单一时段的画面能反映管理状态，但难以代表全部流程，理性判断需要结合复查结论。" },
      { title: "公开整改比口头保证更可信", desc: "餐厅公示整改措施后，负面讨论明显回落，说明可验证的行动比声明更能安抚消费者。" },
      { title: "探店内容需要边界意识", desc: "内容创作者在公共监督与商业探店之间需要更清晰的标注与素材留存，才能经得起反向核查。" },
    ],
  },
];

export const hotRanking = [
  { id: "qinghe-lianming", title: "青禾乳业联名定价争议", heat: 92, label: "品牌风波" },
  { id: "shenglang-tuipiao", title: "声浪音乐节退票事件", heat: 88, label: "活动现场" },
  { id: "yunfan-shouhou", title: "云帆直播间售后风波", heat: 84, label: "电商消费" },
  { id: "xingye-jianji", title: "星野剧场综艺剪辑争议", heat: 79, label: "内容争议" },
  { id: "mulin-duanju", title: "沐林短剧版权之争", heat: 71, label: "版权纠纷" },
  { id: "haiyu-canting", title: "海屿餐厅卫生质疑", heat: 66, label: "消费质疑" },
];

export function getTopicById(id: string): Topic | undefined {
  return topics.find((item) => item.id === id);
}

export function getCategoryById(id: string): Category | undefined {
  return categories.find((item) => item.id === id);
}